export default {
  destroyed() {
    const htmlElement = document.querySelector('html');
    htmlElement.removeAttribute('style');
  },
  computed: {
    visiblePopupDuplication() {
      if (this.visible !== undefined) {
        return this.visible;
      }
      if (this.internalValue !== undefined) {
        return this.internalValue;
      }
      return this.visiblePopup;
    },
  },
  methods: {
    disableOuterScrollWhenPopupOpen(popupVisibleValue) {
      if (popupVisibleValue) {
        const htmlElement = document.querySelector('html');
        htmlElement.setAttribute('style', 'overflow-y: hidden;');
      } else {
        const htmlElement = document.querySelector('html');
        htmlElement.removeAttribute('style');
      }
    },
  },
  watch: {
    visiblePopupDuplication() {
      this.disableOuterScrollWhenPopupOpen(this.visiblePopupDuplication);
    },
  },
};
